import { render } from "./SummaryNav.vue?vue&type=template&id=41002414&ts=true"
import script from "./SummaryNav.vue?vue&type=script&lang=ts"
export * from "./SummaryNav.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__